/**
 * The engine's own failure sentences, in words a Paige customer can act on. The engine is
 * CapturePoint's, ported (docs/engineering/workbench-port.md): its messages name the desktop's
 * parts ("the local page recogniser", "the OCR pool") and they come back with every sync, so
 * Paige rewords them here, where an engine answer enters the page, rather than in the engine.
 * Found on the first customer run in production (2026-09-30): setup stopped with "The local page
 * recogniser failed 6 pages in a row ... The OCR pool could not be reached."
 */
const rules: { match: RegExp; say: string }[] = [
  {
    match: /page recogni[sz]er failed \d+ pages in a row/i,
    say: 'Cortexa could not read the pages just now, so setup stopped before keeping any of them. Nothing was kept. Try again in a few minutes.',
  },
  {
    match: /(OCR|understanding) pool could not be reached|reading model could not be reached/i,
    say: 'Cortexa could not be reached just now. Nothing was lost. Try again in a few minutes.',
  },
];

/** The words for the reader behind each engine name, where a sentence is otherwise fine as it is. */
const names: [RegExp, string][] = [
  [/\bthe (local )?page recogni[sz]er\b/gi, 'Cortexa'],
  [/\bthe (OCR|understanding) pool\b/gi, 'Cortexa'],
  [/\bthe reading (model|runtime)\b/gi, 'Cortexa'],
  // The engine's desktop product, in the few sentences it still writes outright (pre-sale check, 2026-10-10:
  // "CapturePoint could not reliably match every line item to the table").
  [/\bCapturePoint\b/g, 'Paige'],
];

export function customerWords(message: string): string {
  const rule = rules.find((candidate) => candidate.match.test(message));
  if (rule) return rule.say;
  return names.reduce((text, [pattern, word]) => text.replace(pattern, word), message);
}
